import React from 'react';
import styled from 'styled-components';
import SGTitle from 'components/Typography/SGTitle';
import SGBody from 'components/Typography/SGBody';
import SiteIDSearch from 'components/SiteIDSearch';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';

const SwitchSelectionPromptContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const StyledSGBody = styled(SGBody)`
  margin-bottom: 24px;
`;

interface SwitchSelectionPromptProps {
  setSwitchError: (error: string) => void;
  clickHandler?: (site: Site) => void;
}

function SwitchSelectionPrompt({setSwitchError, clickHandler}: SwitchSelectionPromptProps) {
  return (
    <SwitchSelectionPromptContainer>
      <SGTitle variant={'t3'} className={'text-color'}>
        Switch Connectivity Search
      </SGTitle>
      <StyledSGBody className={'text-color'}>
        Use the search bar below to locate devices, find available ports, check port and device
        status, view port configurations, and switches for all site types.
      </StyledSGBody>
      <SiteIDSearch
        urlType={'switch'}
        alignment="left"
        setError={setSwitchError}
        clickHandler={clickHandler}
      />
    </SwitchSelectionPromptContainer>
  );
}

export default SwitchSelectionPrompt;
